module.exports = __webpack_public_path__ + "static/media/downloadFile.410c088e.svg";